import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import useUserQuery from '../../hooks/queries/useUserQuery';
import { useAdPopcorn } from '../../chat/hooks/useAdPopcorn';

interface FreeHeartChargeCardProps {
  item: {
    id: number;
    title: string;
    description: string;
    icon: string;
    type: 'invite' | 'adpopcorn';
  };
}

const FreeHeartChargeCard = ({ item }: FreeHeartChargeCardProps) => {
  const navigate = useNavigate();

  const { data: user } = useUserQuery();
  const { setUserId, openOfferwall, getRewardInfo, rewardInfo } = useAdPopcorn();

  useEffect(() => {
    if (user) {
      setUserId(user.userId);
    }
  }, [user, setUserId]);

  useEffect(() => {
    getRewardInfo();
  }, [getRewardInfo]);

  const handleClick = () => {
    if (item.type === 'invite') {
      if (!user?.identified) {
        navigate('/identity-verification/intro?type=invite');
      } else {
        navigate('/free-charge/invite');
      }
      return;
    }

    if (item.type === 'adpopcorn') {
      openOfferwall();
    }
  };

  const rewardInfoText = rewardInfo
    ? (rewardInfo as any)?.point > 1000
      ? '1,000+'
      : (rewardInfo as any)?.point.toString()
    : '0';

  return (
    <button
      type="button"
      className="relative z-[10] bg-background-elevated min-w-[155px] pt-[12px] pr-[12px] pb-[14px] pl-[14px] rounded-[16px] w-full shadow-[0_4px_10px_0_rgba(0,0,0,0.04),_0_0_24px_0_rgba(255,255,255,0.30)_inset] dark:shadow-[0_4px_10px_0_rgba(255,255,255,0.04),0_0_24px_0_rgba(0,0,0,0.30)_inset] backdrop:filter-blur-[20px]"
      onClick={handleClick}
    >
      <div className="flex justify-end">
        <div className="rounded-full bg-surface-lv2 p-[7.5px] w-fit h-fit">
          <img src={item.icon} alt={item.title} className="w-[26px] h-[26px]" />
        </div>
      </div>
      <p className="text-[12px] font-semibold bg-gradient-single-red bg-clip-text text-transparent leading-[14px] text-left">
        {t(item.description, { count: rewardInfoText })}
      </p>
      <p className="text-[15px] font-semibold text-text-main-lv2 leading-[18px] whitespace-pre-line mt-[6px] text-left">
        {item.title}
      </p>
    </button>
  );
};

export default FreeHeartChargeCard;
